import { GetStaticProps } from 'next'
import { SimpleFlowSignupForm } from 'components/SimpleFlowSignupForm/SimpleFlowSignupForm'
import { getIntlProps } from 'utils/i18n/getIntlProps'
import { useEffect } from 'react'
import cookie from 'js-cookie'
import { useRouter } from 'next/router'

declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

export default function IframeSignupPage() {
  const { promo } = useRouter().query

  useEffect(() => {
    // Set cookie consent cookie first
    cookie.set('consent', 'v2', { expires: 365 })

    // Update gtag consent settings
    function allConsentGranted() {
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          ad_storage: 'granted',
          analytics_storage: 'granted',
        })
      }
    }

    allConsentGranted()
  }, [])

  return <SimpleFlowSignupForm external={true} promo={promo as string} />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, ['entrance', 'pricing_plan', 'auth'])) } }
}
